<template>
  <AppDialog
    :open="visible"
    :from="from"
    @close="$listeners.close"
    classes="forgot-password-dialog"
    title="Passwort zurücksetzen"
  >
    <p>
      Bitte geben Sie ihre E-Mail Adresse an, mit der Sie bei FactField
      registriert sind.
    </p>
    <ForgotPasswordForm @submit="handleForm" />
    <p></p>
    <p>
      Haben Sie Fragen? Nutzen Sie einfach unser
      <t-button type="link" classes="inline-button" :action="handleContact"
        >Kontaktformular</t-button
      >.
    </p></AppDialog
  >
</template>

<script>
import AppDialog from "@/components/Dialog/AppDialog";
import ForgotPasswordForm from "@/components/Forms/ForgotPasswordForm";
import TButton from "@/components/Layout/Button";

export default {
  name: "ForgotPasswordDialog",
  components: { TButton, ForgotPasswordForm, AppDialog },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    from: {
      type: String,
      default: () => "main",
    },
  },
  methods: {
    handleForm() {
      this.$listeners.close();
    },
    handleContact() {
      this.$listeners.close();
      window.location.href = "/#kontakt";
    },
  },
};
</script>

<style lang="postcss">
.forgot-password-dialog {
  h2 {
    @apply mt-8;
  }

  p {
    @apply mb-8;
  }
}
</style>
